(function () {
  var path = window.location.pathname.replace(/\/$/, '');
  if (path !== '/products/airpods-pro-2nd-generation') return;
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  function initResetPro2MobileSales() {
    var root = document.querySelector('.ap-page');
    if (!root || root.dataset.resetPro2MobileSales === 'true') return;
    root.dataset.resetPro2MobileSales = 'true';

    var buyPanel = root.querySelector('.ap-buy-panel');
    var actionRow = root.querySelector('.ap-action-row');
    var benefits = root.querySelector('.ap-benefits');
    var tradeNo = root.querySelector('[data-ap-trade-no]');
    var tradeSection = tradeNo ? tradeNo.closest('.ap-choice-section') : null;
    var shortCopy = root.querySelector('.ap-short-copy');

    if (shortCopy) {
      shortCopy.textContent = 'Choose Lightning or USB-C, then select the exact left, right or charging case replacement by model number.';
    }

    if (tradeSection && benefits) {
      benefits.insertAdjacentElement('afterend', tradeSection);
    }

    if (buyPanel && actionRow && !root.querySelector('.reset-pro2-purchase-trust')) {
      var trust = document.createElement('div');
      trust.className = 'reset-pro2-purchase-trust';
      trust.setAttribute('aria-label', 'Purchase benefits');
      trust.innerHTML = '<span>Genuine Apple</span><span>Free tracked delivery</span><span>30-day returns</span>';
      actionRow.parentNode.insertBefore(trust, actionRow);
    }

    function bypassTradeInUpsell(button) {
      if (!button) return;
      button.addEventListener('click', function () {
        var upsell = root.querySelector('[data-ap-detail-modal="trade-in-upsell"]');
        var notNow = upsell ? upsell.querySelector('[data-ap-upsell-not-now]') : null;
        if (upsell && upsell.classList.contains('is-open') && notNow) {
          notNow.click();
        }
      });
    }

    bypassTradeInUpsell(root.querySelector('.ap-add'));
    bypassTradeInUpsell(root.querySelector('[data-ap-fb-btn]'));

    if (!document.getElementById('reset-pro2-mobile-sales-style')) {
      var style = document.createElement('style');
      style.id = 'reset-pro2-mobile-sales-style';
      style.textContent = [
        '@media (max-width:749px){',
        '.reset-pro2-purchase-trust{display:flex;flex-wrap:wrap;gap:6px;margin-top:18px}',
        '.reset-pro2-purchase-trust span{min-height:30px;padding:0 10px;border-radius:999px;background:#f7f7f8;border:1px solid rgba(0,0,0,.06);color:#1d1d1f;display:inline-flex;align-items:center;font-size:11px;font-weight:750}',
        '.ap-page [data-ap-detail-modal="trade-in-upsell"].is-open{visibility:hidden}',
        '}'
      ].join('');
      document.head.appendChild(style);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initResetPro2MobileSales);
  } else {
    initResetPro2MobileSales();
  }
})();
